import React from 'react';
import { useSystemTransactionSettings } from '../hooks/use-system-transaction-settings.js';
import SystemTransactionSettingsPageView from './system-transaction-settings-page-view.jsx';
import PaymentPolicySettings from './payment-policy-settings.jsx';

function SystemTransactionSettingsPageContainer() {
  const state = useSystemTransactionSettings();

  return <><SystemTransactionSettingsPageView {...state} /><PaymentPolicySettings /></>;
}

export default SystemTransactionSettingsPageContainer;
